var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGitlabIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_67)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.053 22.5629L55.9728 22.3503L48.2143 1.32603C48.0564 0.913967 47.7769 0.564412 47.4158 0.327519C47.0545 0.0946517 46.6331 -0.017505 46.2085 0.00619294C45.7839 0.0298909 45.3765 0.188302 45.0414 0.460038C44.7099 0.739576 44.4695 1.11836 44.3528 1.54484L39.1141 18.1867H17.9011L12.6624 1.54484C12.5488 1.11604 12.3079 0.735354 11.9738 0.456956C11.6387 0.18522 11.2313 0.0268084 10.8067 0.00311045C10.382 -0.0205875 9.96064 0.0915692 9.59935 0.324437C9.23911 0.562286 8.95985 0.911535 8.80094 1.32295L1.0275 22.3379L0.950332 22.5506C-0.166554 25.5807 -0.304415 28.9056 0.557534 32.0241C1.41948 35.1427 3.23451 37.8857 5.72896 39.8396L5.75568 39.8612L5.82691 39.9136L17.6459 49.1036L23.493 53.6986L27.0547 56.4908C27.4713 56.8192 27.98 56.997 28.5031 56.997C29.0262 56.997 29.535 56.8192 29.9516 56.4908L33.5133 53.6986L39.3604 49.1036L51.2506 39.8581L51.2803 39.8335C53.7691 37.8792 55.5799 35.139 56.4406 32.0246C57.3012 28.9103 57.1652 25.5901 56.053 22.5629Z",
    fill: "url(#paint0_linear_197_67)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_67",
    x1: 3.83878,
    y1: 7.44525,
    x2: 57.0133,
    y2: 19.0391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC221F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#861311"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_67"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlabIcon);
export default __webpack_public_path__ + "static/media/gitlab-icon.a002c112f3cf326d5b985fe4cc3944fe.svg";
export { ForwardRef as ReactComponent };